import { useTranslation } from "react-i18next";
import { HiChevronRight } from "react-icons/hi";
import { useNavigate } from "react-router";

const boxClassName =
  "flex items-center gap-[10px] cursor-pointer group text-base-light-dark dark:text-base-input-dark-text font-medium hover:bg-menu-background-hover hover:dark:bg-base-light-dark rounded-[5px] py-[12px] px-[16px]";
const textClassName =
  "text-base-light-dark dark:text-base-input-dark-text group-hover:text-main-color";

const BoxItems = ({
  icon,
  text,
  notTranslate,
  path,
  wrapperClassName,
  wrapperTextClassName,
  hiddenArrow,
  onClick,
}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const navigate = useNavigate();
  return (
    <div
      className={`${boxClassName} ${wrapperClassName}  md:bg-transparent bg-base-light-white dark:bg-base-input-gray flex items-center justify-between`}
      onClick={() => {
        navigate(path);
        onClick && onClick();
      }}
    >
      <div className="flex items-center gap-1">
        <span className="w-[31px] h-[21px]">{icon}</span>
        <span className={`${textClassName} ${wrapperTextClassName}`}>
          {notTranslate ? text : i18n(text)}
        </span>
      </div>
      {hiddenArrow || (
        <HiChevronRight className="md:hidden text-2xl text-dark-gray-text dark:text-base-input-dark-text" />
      )}
    </div>
  );
};

export default BoxItems;
